export const ArchiveAddIcon = () => {
  return (
    <svg
      className="hover:text-darkblue text-[#9CA3AF]"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M12.0797 3.31725L12.1733 3.49564H12.3748H21.0373C22.1353 3.49564 23.029 4.36592 23.029 5.44981V19.2873C23.029 20.3782 22.1657 21.2415 21.0748 21.2415H2.96231C1.8714 21.2415 1.00814 20.3782 1.00814 19.2873V2.7123C1.00814 1.6214 1.8714 0.758138 2.96231 0.758138H9.56231C10.291 0.758138 10.9339 1.16809 11.2937 1.82022L12.0797 3.31725ZM21.0748 20.2206C21.5964 20.2206 22.0081 19.8089 22.0081 19.2873V5.44981C22.0081 4.92821 21.5964 4.51647 21.0748 4.51647H11.8873C11.718 4.51647 11.525 4.40351 11.4286 4.23761L10.383 2.29583C10.2158 1.96555 9.91686 1.77897 9.56231 1.77897H2.96231C2.44071 1.77897 2.02897 2.19071 2.02897 2.7123V19.2873C2.02897 19.8089 2.44071 20.2206 2.96231 20.2206H21.0748Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M14.6997 12.4242L12.8622 14.2242V8.74922C12.8622 8.29922 12.4872 7.88672 11.9997 7.88672C11.5122 7.88672 11.1372 8.26172 11.1372 8.74922V14.2617L9.26221 12.4242C8.92471 12.0867 8.39971 12.0867 8.06221 12.4242C7.72471 12.7617 7.72471 13.2867 8.06221 13.6242L11.3622 16.8492C11.5122 16.9992 11.7372 17.0742 11.9622 17.0742C12.1872 17.0742 12.3747 16.9992 12.5622 16.8492L15.8622 13.6242C16.1997 13.2867 16.1997 12.7617 15.8622 12.4242C15.5622 12.0867 15.0372 12.0867 14.6997 12.4242Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArchiveRemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="hover:text-darkblue text-[#9CA3AF]"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
    >
      <path
        d="M12.0806 3.31823L12.1743 3.49662H12.3758H21.0383C22.1363 3.49662 23.0299 4.3669 23.0299 5.45078V19.2883C23.0299 20.3792 22.1667 21.2425 21.0758 21.2425H2.96328C1.87238 21.2425 1.00911 20.3792 1.00911 19.2883V2.71328C1.00911 1.62238 1.87238 0.759115 2.96328 0.759115H9.56328C10.292 0.759115 10.9349 1.16907 11.2947 1.8212L12.0806 3.31823ZM21.0758 20.2216C21.5974 20.2216 22.0091 19.8099 22.0091 19.2883V5.45078C22.0091 4.92919 21.5974 4.51745 21.0758 4.51745H11.8883C11.719 4.51745 11.526 4.40449 11.4295 4.23858L10.384 2.2968C10.2168 1.96652 9.91784 1.77995 9.56328 1.77995H2.96328C2.44169 1.77995 2.02995 2.19169 2.02995 2.71328V19.2883C2.02995 19.8099 2.44169 20.2216 2.96328 20.2216H21.0758Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M12.6004 8.14961C12.2629 7.81211 11.7379 7.81211 11.4004 8.14961L8.13789 11.3746C7.80039 11.7121 7.80039 12.2371 8.13789 12.5746C8.47539 12.9121 9.00039 12.9121 9.33789 12.5746L11.1754 10.7746V16.2496C11.1754 16.6996 11.5504 17.1121 12.0379 17.1121C12.5254 17.1121 12.8629 16.7371 12.8629 16.2496V10.7371L14.7379 12.5746C14.8879 12.7246 15.1129 12.7996 15.3379 12.7996C15.5629 12.7996 15.7879 12.7246 15.9379 12.5371C16.2754 12.1996 16.2754 11.6746 15.9379 11.3371L12.6004 8.14961Z"
        fill="currentColor"
      />
    </svg>
  );
};
